var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-h6",staticStyle:{"font-weight":"900","color":"#3c4043"},style:(_vm.instyle)},[(_vm.$slots.heading)?_vm._t("heading"):_vm._e()],2),_c('p',{staticStyle:{"line-height":"1.3"}},[(_vm.$slots.content)?_vm._t("content"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }